import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Divider,
  Image,
  Input,
  Modal,
  Row,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPhotoUrl } from "utils/common";
import Actions from "./components/Actions";
import PlaceDetailModal from "./components/DetailModal";
import * as placeActions from "./slice";

const { Paragraph } = Typography;

function Place() {
  const dispatch = useDispatch();
  const { places, pagination, isLoading, isProcessing, isCompleted } =
    useSelector((state) => state.bikePlace);

  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [selectingPlace, setSelectingPlace] = useState(null);
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    dispatch(placeActions.fetchPlaces(pagination));
  }, []);

  useEffect(() => {
    if (isCompleted) {
      setOpenDetailModal(false);
      setSelectingPlace(null);
    }
  }, [isCompleted]);

  const onOpenDetailModal = (place = null) => {
    setSelectingPlace(place);
    setOpenDetailModal(true);
  };

  const onDelete = (place) => {
    Modal.confirm({
      title: `Xác nhận xoá địa điểm`,
      content: `Bạn có chắc chắn muốn xoá địa điểm này?`,
      onOk: () => dispatch(placeActions.deletePlace(place._id)),
      centered: true,
    });
  };

  const onSubmit = (place, formData) => {
    if (place._id) {
      dispatch(placeActions.updatePlace(place, formData));
    } else {
      dispatch(placeActions.createPlace(formData));
    }
  };

  const onCancel = () => {
    setOpenDetailModal(false);
    setSelectingPlace(null);
    dispatch(placeActions.setIsProcessing(false));
  };

  const onChangeNameSearch = (e) => {
    setSearchName(e.target.value);
  };

  const onSearch = () => {
    dispatch(
      placeActions.fetchPlaces({
        ...pagination,
        name: searchName,
      })
    );
  };

  const onTableChange = async (pagination) => {
    dispatch(
      placeActions.fetchPlaces({
        ...pagination,
        name: searchName,
      })
    );
  };
  const columns = [
    {
      title: "STT",
      align: "center",
      width: "5%",
      render: (text, record, index) => (
        <Typography.Paragraph
          copyable={{
            text: record._id,
            tooltips: ["Sao chép ID", "Đã sao chép!"],
          }}
        >
          {(pagination.current - 1) * pagination.pageSize + index + 1}
        </Typography.Paragraph>
      ),
    },
    {
      title: "Hình ảnh",
      dataIndex: "image",
      width: "280px",
      render: (image) =>
        image ? (
          <Image
            alt="Image of place"
            src={getPhotoUrl(image?.path || null)}
            width={250}
            height={100}
          />
        ) : null,
    },
    {
      title: "Tên địa điểm",
      ellipsis: {
        showTitle: false,
      },
      render: (record) => (
        <>
          <Paragraph strong>{record.name}</Paragraph>
          <a
            href={`https://www.google.com/maps?q=${record.lat},${record.long}`}
            target="_blank"
            rel="noreferrer"
          >
            <Typography.Text className="whitespace-nowrap">
              {record.address}
            </Typography.Text>
          </a>
        </>
      ),
    },
    {
      title: "Ưu tiên",
      dataIndex: "priority",
      align: "center",
      width: "10%",
      sorter: (a, b) => a.priority - b.priority,
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      align: "center",
      width: 150,
      render: (active) =>
        active ? (
          <Tag color="#4caf50">Active</Tag>
        ) : (
          <Tag color="#f44336">In-active</Tag>
        ),
    },
    {
      title: "Thao tác",
      align: "center",
      width: "15%",
      render: (record) => (
        <Actions
          record={record}
          onEdit={onOpenDetailModal}
          onDelete={onDelete}
        />
      ),
    },
  ];
  return (
    <>
      <Row justify="space-between" align="middle">
        <Typography.Title level={2}>
          [{pagination?.total || "0"}] Địa điểm gợi ý
        </Typography.Title>
        <Space size="middle">
          <Input.Search
            placeholder="Tìm theo tên"
            onChange={onChangeNameSearch}
            onSearch={onSearch}
            enterButton
            allowClear
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => onOpenDetailModal()}
          >
            Thêm mới
          </Button>
        </Space>
      </Row>
      <Divider />
      <Table
        bordered
        loading={isLoading}
        columns={columns}
        dataSource={places}
        rowKey={(record) => record._id}
        pagination={pagination}
        onChange={onTableChange}
      />
      {openDetailModal && (
        <PlaceDetailModal
          open={openDetailModal}
          isProcessing={isProcessing}
          onSubmit={onSubmit}
          onCancel={onCancel}
          place={selectingPlace}
        />
      )}
    </>
  );
}

export default Place;
